export default __webpack_public_path__ + "static/media/tipo_de_requerimientos.fd443405.svg";